module.exports = __webpack_public_path__ + "static/media/tesla.89c55134.jpg";